var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignInCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.21491 31.7851C10.5458 34.116 13.5155 35.7033 16.7485 36.3464C19.9815 36.9895 23.3326 36.6595 26.3781 35.398C29.4235 34.1365 32.0265 32.0003 33.8578 29.2595C35.6892 26.5187 36.6667 23.2964 36.6667 20C36.6667 16.7036 35.6892 13.4813 33.8578 10.7405C32.0265 7.99967 29.4235 5.86346 26.3781 4.602C23.3326 3.34054 19.9815 3.01049 16.7485 3.65357C13.5155 4.29666 10.5458 5.88401 8.21491 8.21488",
    stroke: "#0A0D1F",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 20L26.1713 19.063L26.9209 20L26.1713 20.937L25 20ZM5 21.5C4.17157 21.5 3.5 20.8284 3.5 20C3.5 19.1716 4.17157 18.5 5 18.5V21.5ZM19.5046 10.7296L26.1713 19.063L23.8287 20.937L17.162 12.6037L19.5046 10.7296ZM26.1713 20.937L19.5046 29.2704L17.162 27.3963L23.8287 19.063L26.1713 20.937ZM25 21.5H5V18.5H25V21.5Z",
    fill: "#0A0D1F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignInCircle);
export default __webpack_public_path__ + "static/media/Sign_in_circle.a1340ba8.svg";
export { ForwardRef as ReactComponent };